const oviQuestions = [
    {
        title: 'Våra visioner och mål är tydliga för mig',
        type: 'numbers',
        hints: [
            '1 = visioner och mål är otydliga och hjälper mig inte i arbetet',
            '6 = visioner och mål är tydliga och hjälper mig i arbetet'
        ],
    },
    {
        title: 'Jag upplever att jag bidrar till organisationens önskade resultat.',
        type: 'numbers',
        hints: [
            '1 = vid ett fåtal tillfällen under en vecka känns mitt arbete viktigt för resultatet',
            '6 = varje dag känns mitt arbete viktigt för resultatet'
        ],
    },
    {
        title: 'Jag prioriterar i mitt arbete varje dag.',
        type: 'numbers',
        hints: [
            '1 = jag går mestadels på rutin och prioriterar vid ett fåtal tillfällen under en vecka',
            '6 = varje dag gör jag meningsfulla prioriteringar utifrån verksamhetens behov'
        ],
    },
    {
        title: 'Mina ansvarsområden är tydliga och jag är väl insatt i mina mål.',
        type: 'numbers',
        hints: [
            '1 = gränserna för mitt arbetsområde och mina mål är oklara',
            '6 = gränserna för mitt arbetsområde och mina mål är tydliga och kända av kollegorna'
        ],
    },
    {
        title: 'Jag har de resurser (kunskaper, mandat, verktyg etc) jag behöver för att hantera mina arbetsuppgifter.',
        type: 'numbers',
        hints: [
            '1 = jag känner mig ofta osäker när jag ska utföra mina arbetsuppgifter',
            '6 = jag känner mig lugn, trygg och kan hantera mina arbetsuppgifter varje dag'
        ],
    },
    {
        title: 'Organisationens värderingar stämmer väl med mina.',
        type: 'numbers',
        hints: [
            '1 = oftast inte, mina värderingar skiljer sig från organisationens',
            '6 = oftast, organisationens och mina värderingar är väldigt lika'
        ],
    },
    {
        title: 'Mitt arbete ger mig meningsfullhet och engagerar mig.',
        type: 'numbers',
        hints: [
            '1 = för mig är arbetet ett sätt att försörja mig, jag hittar meningsfullhet och engagemang utanför arbetet',
            '6 = arbetet ger mig mycket mer än försörjning, det är meningsfullt och engagerar mig'
        ],
    },
    {
        title: 'Jag har tillit till min chef och vågar visa mina svagheter.',
        type: 'numbers',
        hints: [
            '1 = jag vågar vanligtvis inte säga vad jag tänker och visa svaghet för min chef',
            '6 = jag har hög tillit till min chef och kan säga precis vad jag tänker och känner'
        ],
    },
    {
        title: 'Vi kollegor hjälper och stödjer varandra när det behövs för att uppnå målen.',
        type: 'numbers',
        hints: [
            '1 = var och en får vanligtvis klara sig själv',
            '6 = vi kan be varandra om hjälp'
        ],
    },
    {
        title: 'Jag känner att jag är inkluderad i gemenskapen och kan vara mig själv i gruppen.',
        type: 'numbers',
        hints: [
            '1 = jag känner mig ofta utanför och tycker det ofta är svårt att vara mig själv',
            '6 = jag känner mig trygg i gruppen och kan vara mig själv i de flesta situationer'
        ],
    },
    {
        title: 'Jag hinner integrera de förändringar som görs, det nya blir en del av min arbetsvardag.',
        type: 'numbers',
        hints: [
            '1 = oftast inte, för allt ska gå så fort och det är ständigt nya förändringar',
            '6 = oftast hinner jag det, och förändringar följs upp och utvärderas på ett bra sätt'
        ],
    },
    {
        title: 'Jag har stort förtroende för högsta ledningen, de verkar ha bra koll på vägen framåt och hur organisationen fungerar.',
        type: 'numbers',
        hints: [
            '1 = jag tvivlar på ledningens förmåga och kan känna oro inför framtiden',
            '6 = jag har stort förtroende för ledningen och tycker att de mestadels fattar kloka beslut'
        ],
    },
    
];

export default oviQuestions;